import { render, staticRenderFns } from "./MeliorPlayer.vue?vue&type=template&id=08dc0c02&"
import script from "./MeliorPlayer.vue?vue&type=script&lang=js&"
export * from "./MeliorPlayer.vue?vue&type=script&lang=js&"
import style0 from "./MeliorPlayer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports